var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 72,
    viewBox: "0 0 63 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.1412 24.5495C59.7787 24.7604 51.8065 29.1397 51.8971 38.2503C51.9973 49.1476 62.0218 52.7765 62.137 52.8177C62.0472 53.0771 60.5343 57.9862 56.8528 63.0562C53.6712 67.4484 50.3755 71.8158 45.1738 71.9069C40.0634 71.9952 38.4163 69.046 32.5782 69.046C26.7365 69.046 24.9081 71.8157 20.0754 71.9952C15.0546 72.1745 11.2321 67.2522 8.02708 62.8841C1.47511 53.9448 -3.53437 37.621 3.1922 26.6047C6.53165 21.1337 12.5005 17.6676 18.9769 17.578C23.9091 17.4901 28.5606 20.7065 31.5776 20.7065C34.5514 20.7065 39.8812 16.9571 46.1637 17.3956C48.626 17.5678 55.6158 18.2611 60.1412 24.5495ZM42.2872 11.4944C44.9554 8.45184 46.7506 4.21455 46.2563 0C42.4161 0.14369 37.7715 2.41352 35.0171 5.45415C32.5505 8.14768 30.3843 12.4617 30.9724 16.5902C35.2527 16.9022 39.6213 14.5389 42.2872 11.4944Z",
    fill: "#A38150"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.df1acd8b7623eb9764dec7a3a795d057.svg";
export { ForwardRef as ReactComponent };